<div class="min-h-full bg-[#fafaf7] font-sans">
  <div class="max-w-[1200px] mx-auto px-5 sm:px-8 py-8 space-y-6">

    <!-- Filters -->
    <div class="bg-white rounded-2xl border border-stone-100 shadow-sm px-6 py-4 space-y-3">
      <div class="flex flex-wrap items-center gap-3">
        <div class="relative flex-1 min-w-[200px]">
          <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
          </svg>
          <input type="text" placeholder="Rechercher par nom…"
            [value]="searchQuery()"
            (input)="onSearchChange($any($event).target.value)"
            class="w-full pl-9 pr-4 py-2 border border-stone-200 rounded-lg text-sm focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-all" />
        </div>
        <select [value]="selectedType()" (change)="onTypeChange($any($event).target.value)"
          class="select-chevron pl-3 pr-9 py-2 border border-stone-200 rounded-lg text-sm focus:outline-none focus:border-primary-300 transition-all flex-1 sm:flex-none min-w-0">
          <option value="">Tous les types</option>
          <option value="PLAY">Joueurs</option>
          <option value="COACH">Entraîneurs</option>
          <option value="MANA">Dirigeants</option>
          <option value="CLUB">Clubs</option>
          <option value="COMP">Compétitions</option>
        </select>
        <button (click)="onAddNew()"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors text-xs font-medium flex-shrink-0 w-full sm:w-auto justify-center min-h-[40px] sm:ml-auto">
          <span class="material-icons text-base">add</span>
          Ajouter un formulaire
        </button>
      </div>
      @if (searchQuery() || selectedType()) {
        <div class="flex justify-end">
          <button type="button" (click)="onSearchChange(''); onTypeChange('')"
            class="text-xs text-stone-400 hover:text-stone-600 transition-colors">
            Réinitialiser les filtres
          </button>
        </div>
      }
    </div>

    <!-- Loading -->
    @if (isLoading()) {
      <div class="flex items-center justify-center py-24">
        <div class="relative w-10 h-10">
          <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
          <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
        </div>
      </div>
    }

    <!-- Groups -->
    @if (!isLoading()) {
      @if (Object.keys(groups()).length === 0) {
        <div class="flex flex-col items-center gap-3 py-24 text-center">
          <div class="w-14 h-14 rounded-3xl bg-stone-100 flex items-center justify-center">
            <span class="material-icons text-stone-300 text-3xl">description</span>
          </div>
          <p class="text-stone-500 text-sm font-medium">Aucun formulaire disponible</p>
        </div>
      }

      @for (type of Object.keys(groups()); track type) {
        <div class="space-y-3">
          <h3 class="text-[11px] font-bold uppercase tracking-widest text-stone-400 px-1">{{ typeLabels[type] || type }}</h3>
          <div class="bg-white rounded-2xl border border-stone-100 shadow-sm overflow-hidden">
            @for (formulaire of groups()[type]; track formulaire.formulaire_id; let last = $last) {
              <div class="flex items-center gap-4 px-5 py-4 hover:bg-stone-50 transition-colors cursor-pointer"
                [class.border-b]="!last" [class.border-stone-50]="!last"
                (click)="onViewDetail(formulaire.formulaire_id)">

                <!-- Icon -->
                <div class="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
                  [style.background-color]="formulaire.formulaire_status === 'ACTI' ? '#5998e5' : '#d6d3d1'">
                  <svg fill="white" viewBox="0 0 24 24" class="w-4 h-4">
                    <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                  </svg>
                </div>

                <!-- Info -->
                <div class="flex-1 min-w-0 flex items-center gap-3 flex-wrap">
                  @if (formulaire.formulaire_code) {
                    <span class="text-[11px] font-mono bg-stone-100 px-2 py-0.5 rounded text-stone-600 flex-shrink-0">{{ formulaire.formulaire_code }}</span>
                  }
                  <span class="text-sm font-medium text-stone-800 truncate">{{ formulaire.formulaire_nom_fr }}</span>
                  @if (formulaire.formulaire_nom_ar) {
                    <span class="text-sm text-stone-500 truncate" dir="rtl">{{ formulaire.formulaire_nom_ar }}</span>
                  }
                </div>

                <!-- Status badge -->
                <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-semibold border flex-shrink-0"
                  [class]="formulaire.formulaire_status === 'ACTI'
                    ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
                    : 'bg-amber-50 text-amber-700 border-amber-200'">
                  <span class="w-1.5 h-1.5 rounded-full"
                    [class]="formulaire.formulaire_status === 'ACTI' ? 'bg-emerald-500' : 'bg-amber-400'"></span>
                  {{ formulaire.formulaire_status_label || (formulaire.formulaire_status === 'ACTI' ? 'En ligne' : 'Hors ligne') }}
                </span>

                <!-- Download buttons -->
                <div class="flex items-center gap-2 flex-shrink-0" (click)="$event.stopPropagation()">
                  @if (getFileByExtension(formulaire.files, 'PDF'); as pdfFile) {
                    @if (downloadingFormulaire()?.id === formulaire.formulaire_id && downloadingFormulaire()?.type === 'pdf') {
                      <span class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-red-50 text-red-400">
                        <svg class="w-3 h-3 animate-spin" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                        </svg>
                        Chargement…
                      </span>
                    } @else {
                      <button type="button" (click)="downloadFile(formulaire, pdfFile, 'pdf')"
                        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all bg-red-50 text-red-600 hover:bg-red-100">
                        <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                        </svg>
                        PDF
                      </button>
                    }
                  } @else {
                    <span class="px-3 py-1.5 rounded-lg text-xs font-semibold bg-stone-100 text-stone-400">PDF</span>
                  }
                  @if (getFileByExtension(formulaire.files, 'DOCX'); as docxFile) {
                    @if (downloadingFormulaire()?.id === formulaire.formulaire_id && downloadingFormulaire()?.type === 'docx') {
                      <span class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-blue-50 text-blue-400">
                        <svg class="w-3 h-3 animate-spin" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                        </svg>
                        Chargement…
                      </span>
                    } @else {
                      <button type="button" (click)="downloadFile(formulaire, docxFile, 'docx')"
                        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all bg-blue-50 text-blue-600 hover:bg-blue-100">
                        <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                        </svg>
                        DOCX
                      </button>
                    }
                  } @else {
                    <span class="px-3 py-1.5 rounded-lg text-xs font-semibold bg-stone-100 text-stone-400">DOCX</span>
                  }
                </div>


              </div>
            }
          </div>
        </div>
      }
    }

  </div>
</div>
